import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleLeft,
  faAngleRight,
  faBook,
  faBookOpen,
  faChartBar,
  faCheck,
  faCheckSquare,
  faChessKing,
  faCircle,
  faFileContract,
  faFireAlt,
  faFlask,
  faHeart,
  faHome,
  faMedal,
  faPauseCircle,
  faPlus,
  faSchool,
  faSearchPlus,
  faSignInAlt,
  faSignOutAlt,
  faTag,
  faTasks,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';

// font awesome

export default function initIcons() {
  library.add(faAngleLeft);
  library.add(faAngleRight);
  library.add(faBook);
  library.add(faBookOpen);
  library.add(faChartBar);
  library.add(faHeart);
  library.add(faCheckSquare);
  library.add(faCircle);
  library.add(faFileContract);
  library.add(faHome);
  library.add(faChessKing);
  library.add(faMedal);
  library.add(faFlask);
  library.add(faTimes);
  library.add(faCheck);
  library.add(faPlus);
  library.add(faSchool);
  library.add(faSignInAlt);
  library.add(faSignOutAlt);
  library.add(faTasks);
  library.add(faTag);
  library.add(faSearchPlus);
  library.add(faFireAlt);
  library.add(faPauseCircle);
  Vue.component('font-awesome-icon', FontAwesomeIcon);
}
